import { oneOf } from 'prop-types';
export var ButtonTypes = {
  buttonKind: oneOf(['primary', 'secondary', 'danger', 'ghost', 'danger--primary', 'tertiary'])
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/prop-types/types.js
// module id = 302
// module chunks = 0